import { render, staticRenderFns } from "./cabinet.vue?vue&type=template&id=84930550&"
import script from "./cabinet.vue?vue&type=script&lang=js&"
export * from "./cabinet.vue?vue&type=script&lang=js&"
import style0 from "./cabinet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BookingFormCargo: require('/opt/cargo.front/src/components/booking/form/cargo.vue').default,BookingFormDirection: require('/opt/cargo.front/src/components/booking/form/direction.vue').default})
